import { apiGet, apiPost } from '@/utils/httpClient'

export const externalTranslationApi = {
    getTranslationProviders(sourceLanguageId: number, targetLanguageId: number) {
        return apiGet(`externalTranslation/translationProviders/${sourceLanguageId}/${targetLanguageId}`);
    },

    translateSegment(segment: any) {
        const unsafeCall = true;
        return apiPost('externalTranslation/translateSegment', segment, unsafeCall);
    },

    getTranslationLogs() {
        return apiGet('externalTranslation/log');
    }
}
